import api from '@/lib/api';

export interface SignatureTemplate {
  id: string;
  name: string;
  signature_html: string;
  signature_text: string | null;
  organization_id: string | null;
  is_default: boolean;
  is_active: boolean;
  created_by: string;
  created_at: string;
  updated_at: string;
  organization_name?: string;
  creator_first_name?: string;
  creator_last_name?: string;
  assigned_count?: number;
}

export interface CreateTemplateData {
  name: string;
  signatureHtml: string;
  signatureText?: string;
  organizationId?: string;
  isDefault?: boolean;
}

export interface UpdateTemplateData {
  name?: string;
  signatureHtml?: string;
  signatureText?: string;
  organizationId?: string;
  isDefault?: boolean;
  isActive?: boolean;
}

export interface TemplateAssignment {
  user_id: string;
  organization_id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
}

class SignatureTemplatesService {
  async getTemplates() {
    const response = await api.get<{ success: boolean; data: SignatureTemplate[] }>('/signature-templates');
    return response.data;
  }

  async createTemplate(data: CreateTemplateData) {
    const response = await api.post<{ success: boolean; data: SignatureTemplate }>('/signature-templates', data);
    return response.data;
  }

  async updateTemplate(id: string, data: UpdateTemplateData) {
    const response = await api.put<{ success: boolean; data: SignatureTemplate }>(`/signature-templates/${id}`, data);
    return response.data;
  }

  async deleteTemplate(id: string) {
    const response = await api.delete<{ success: boolean; message: string }>(`/signature-templates/${id}`);
    return response.data;
  }

  async getAssignments(id: string) {
    const response = await api.get<{ success: boolean; data: TemplateAssignment[] }>(`/signature-templates/${id}/assignments`);
    return response.data;
  }

  async assignToUsers(id: string, userIds: string[], organizationId?: string) {
    const response = await api.post<{ success: boolean; data: { assigned: number }; message: string }>(
      `/signature-templates/${id}/assign`,
      { userIds, organizationId }
    );
    return response.data;
  }
}

export default new SignatureTemplatesService();
